import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import { messageActions } from 'Ducks';
import fileServices from './services';
import fileActions from './actions';
import fileTypes from './types';
import { SAGA_REQUEST_KEY } from '../../constants/saga/sagaRequests';

function* uploadFile(action) {
	try {
		let response = yield sagaCallService(
			fileServices.upload,
			action,
			action.payload
		);

		yield put(
			fileActions.uploadSuccess(
				response?.data ? { ...response.data, ...action.payload } : {}
			)
		);
		!action?.payload?.[SAGA_REQUEST_KEY.DISABLE_TOAST] &&
			(yield put(
				messageActions.pushSuccessToast({
					title: 'با موفقیت بارگذاری شد',
				})
			));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, fileActions.uploadFailure);
	}
}

function* deleteFile(action) {
	try {
		let response = yield sagaCallService(
			fileServices.delete,
			action,
			action.payload
		);

		yield put(fileActions.deleteSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, fileActions.deleteFailure);
	}
}

function* readFromFilePath(action) {
	try {
		let response = yield sagaCallService(
			fileServices.readFromPath,
			action,
			action.payload
		);
		yield put(
			fileActions.readFileFromPathSuccess({
				blob: response,
				requestAction: action.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(e, action, fileActions.readFileFromPathFailure);
	}
}

const fileSagas = [
	takeEvery(fileTypes.READ_FROM_PATH.REQUEST, readFromFilePath),
	takeLatest(fileTypes.UPLOAD.REQUEST, uploadFile),
	takeLatest(fileTypes.DELETE.REQUEST, deleteFile),
];

export default fileSagas;
